/**
 * Limits mirrored from the server. Keep in sync with:
 *   MESSAGE_LIMIT      -> server/src/modules/chat/chat.schemas.ts (sendMessageSchema.body.max)
 *   CHAT_IMAGE_*       -> server/src/modules/upload/upload.routes.ts (chatImageUpload)
 */
export const MESSAGE_LIMIT = 2000;
export const CHAT_IMAGE_MAX_BYTES = 15 * 1024 * 1024;
export const CHAT_IMAGE_ALLOWED_MIMES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/heic',
  'image/heif',
];

/** Counter turns amber here, red at the hard limit. */
export const COUNTER_WARN_AT = Math.floor(MESSAGE_LIMIT * 0.9);
